import * as React from 'react';
import { isBrowser } from '../../utils';
var useSafeLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

/**
 * React hook that tracks state of a CSS media query
 *
 * @param queryOrQueries the media query to match
 */
export function useMediaQuery(queryOrQueries) {
  var queries = Array.isArray(queryOrQueries) ? queryOrQueries : [queryOrQueries];
  var isSupported = isBrowser && 'matchMedia' in window;
  var [matches, setMatches] = React.useState(queries.map(query => isSupported ? window.matchMedia(query).matches : false));
  useSafeLayoutEffect(() => {
    if (!isSupported) return undefined;
    var queriesAndListeners = queries.map((query, index) => {
      var mediaQuery = window.matchMedia(query);
      var listener = () => {
        setMatches(prev => prev.map((prevValue, idx) => index === idx ? mediaQuery.matches : prevValue));
      };
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', listener);
      } else {
        mediaQuery.addListener(listener);
      }
      return {
        mediaQuery,
        listener
      };
    });
    return () => {
      queriesAndListeners.forEach(_ref => {
        var {
          mediaQuery,
          listener
        } = _ref;
        if (mediaQuery.removeEventListener) {
          mediaQuery.removeEventListener('change', listener);
        } else {
          mediaQuery.removeListener(listener);
        }
      });
    };
  }, [queryOrQueries]);
  return matches;
}